module.exports = __webpack_public_path__ + "img/login.25bd81a6.png";